import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleCallback, handleMicrosoftCallback, handleGithubCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      // Skip if we've already processed this callback
      if (hasProcessed.current) {
        return;
      }

      // Get the code from URL parameters
      const params = new URLSearchParams(location.search);
      const code = params.get('code');

      if (!code) {
        navigate('/hub');
        return;
      }

      try {
        // Mark as processed before making the API call
        hasProcessed.current = true;

        if (location.pathname === '/auth/google/callback') {
          const redirectPath = await handleGoogleCallback(code);
          navigate(redirectPath || '/hub');
          return;
        }
        if (location.pathname === '/auth/microsoft/callback') {
          const redirectPath = await handleMicrosoftCallback(code);
          navigate(redirectPath || '/hub');
          return;
        }
        if (location.pathname === '/auth/github/callback') {
          await handleGithubCallback(code);
        }

        // Redirect to hub after successful authentication
        navigate('/hub');
      } catch (error) {
        navigate('/hub');
      }
    };

    handleCallback();
  }, [location, navigate, handleGoogleCallback, handleMicrosoftCallback, handleGithubCallback]);

  // Show a loading state while processing
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">Authenticating...</h2>
        <p className="text-gray-500">Please wait while we complete your sign-in.</p>
      </div>
    </div>
  );
};

export default AuthCallback;
